/**
 * @generated SignedSource<<d869c0f0c2fb5784003bcce9db4c3220>>
 * @relayHash 904f50835e8cc620b0cabb83ace484be
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 904f50835e8cc620b0cabb83ace484be

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type AddProjectV2ItemByIdInput = {
  clientMutationId?: string | null | undefined;
  contentId: string;
  projectId: string;
};
export type updateIssueProjectsRelayMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddProjectV2ItemByIdInput;
};
export type updateIssueProjectsRelayMutation$data = {
  readonly addProjectV2ItemById: {
    readonly projectEdge: {
      readonly node: {
        readonly project: {
          readonly closed: boolean;
          readonly hasReachedItemsLimit: boolean;
          readonly id: string;
          readonly number: number;
          readonly title: string;
          readonly url: string;
          readonly viewerCanUpdate: boolean;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ProjectItemSection">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueProjectsRelayMutation$rawResponse = {
  readonly addProjectV2ItemById: {
    readonly projectEdge: {
      readonly node: {
        readonly fieldValueByName: {
          readonly __typename: "ProjectV2ItemFieldSingleSelectValue";
          readonly __isNode: "ProjectV2ItemFieldSingleSelectValue";
          readonly color: ProjectV2SingleSelectFieldOptionColor;
          readonly id: string;
          readonly name: string | null | undefined;
          readonly nameHTML: string | null | undefined;
          readonly optionId: string | null | undefined;
        } | {
          readonly __typename: string;
          readonly __isNode: string;
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly isArchived: boolean;
        readonly project: {
          readonly closed: boolean;
          readonly field: {
            readonly __typename: "ProjectV2SingleSelectField";
            readonly __isNode: "ProjectV2SingleSelectField";
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly options: ReadonlyArray<{
              readonly color: ProjectV2SingleSelectFieldOptionColor;
              readonly description: string;
              readonly descriptionHTML: string;
              readonly id: string;
              readonly name: string;
              readonly nameHTML: string;
              readonly optionId: string;
            }>;
          } | {
            readonly __typename: string;
            readonly __isNode: string;
            readonly id: string;
          } | null | undefined;
          readonly hasReachedItemsLimit: boolean;
          readonly id: string;
          readonly number: number;
          readonly template: boolean;
          readonly title: string;
          readonly url: string;
          readonly viewerCanUpdate: boolean;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueProjectsRelayMutation = {
  rawResponse: updateIssueProjectsRelayMutation$rawResponse;
  response: updateIssueProjectsRelayMutation$data;
  variables: updateIssueProjectsRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasReachedItemsLimit",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueProjectsRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProjectV2ItemByIdPayload",
        "kind": "LinkedField",
        "name": "addProjectV2ItemById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2ItemEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectV2Item",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectItemSection"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueProjectsRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProjectV2ItemByIdPayload",
        "kind": "LinkedField",
        "name": "addProjectV2ItemById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectV2ItemEdge",
            "kind": "LinkedField",
            "name": "projectEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectV2Item",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchived",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectV2",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "template",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "field",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "databaseId",
                                "storageKey": null
                              },
                              (v2/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectV2SingleSelectFieldOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "descriptionHTML",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ProjectV2SingleSelectField",
                            "abstractKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": "field(name:\"Status\")"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "fieldValueByName",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v12/*: any*/),
                          (v11/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "ProjectV2ItemFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": "fieldValueByName(name:\"Status\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "projectEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "904f50835e8cc620b0cabb83ace484be",
    "metadata": {},
    "name": "updateIssueProjectsRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "dbe2b16a81c1878c83467c6e3a8a0a7c";

export default node;
